/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
import { pushRegistrations } from './pushRegistrations'
import { displayMenuPage } from './display/displayMenuPage'
import { displayMassAction } from './display/displayMassAction'
import { displayOrderViewButtons } from './display/displayOrderViewButtons'

async function main(configPath, selectedIds) {
  const { config, imsToken } = await getConfig(configPath)

  pushRegistrations(config)

  let selectedExtension = config.selectedExtensionId
    ? {
        [config.selectedExtensionId]:
          config.extensions[config.selectedExtensionId]
      }
    : null

  if (selectedExtension && !!document.getElementById('uix-page-content')) {
    displayMenuPage(selectedExtension, imsToken)
  }
  if (
    selectedExtension &&
    config.massAction &&
    !!document.getElementById('uix-mass-action')
  ) {
    displayMassAction(config, imsToken, selectedIds, selectedExtension)
  }

  if (
    selectedExtension &&
    config.orderViewButton &&
    !!document.getElementById('uix-order-view-button')
  ) {
    displayOrderViewButtons(config, selectedExtension, imsToken)
  }
}

const getConfig = async (configPath) => {
  const response = await fetch(configPath)
  const result = await response.json()
  const config = result.config
  const imsToken = response.headers.get('X-IMS-Token')
  return { config, imsToken }
}

try {
  await main(
    JSON.parse(document.currentScript.getAttribute('commerce-config')),
    JSON.parse(document.currentScript.getAttribute('selected-ids'))
  )
} catch (e) {
  console.error(e.message)
}
